import ProfessionalDocumentationPage from "../features/staffNotes/ProfessionalDocumentationPage";
import MyNotesTodayPage from '../features/staffNotes/MyNotesTodayPage';
import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import BreadcrumbsComponent from "../components/UI/BreadcrumbsComponent";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import About from "../pages/About";
import ContactUs from "../pages/ContactUs";
import PanelDashboard from "../pages/PanelDashboard";
import ImportHistoryPage from "../pages/ImportHistoryPage";
import HomePage from "../pages/HomePage";
import SourceHistoryPage from "../pages/SourceHistoryPage";
import SourceResultsPage from "../pages/SourceResultsPage";
import CareKnowledgePage from "../pages/CareKnowledgePage";
import PlansPage from "../pages/PlansPage";
import LandingPage from "../pages/LandingPage";
import HowItWorksPage from "../pages/HowItWorksPage";
import CookiePolicyPage from "../pages/CookiePolicyPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import TermsOfServicePage from "../pages/TermsOfServicePage";
import AudienceLandingPage from "../pages/AudienceLandingPage";
import AutismSupportPage from "../pages/AutismSupportPage";
import InteractiveDemoPage from "../pages/InteractiveDemoPage";

// ProgressNotesPage removed - feature deprecated
import SensoryPage from "../pages/SensoryPage";
import CareTeamPage from "../pages/CareTeamPage";
import TemplateLibraryPage from "../pages/TemplateLibraryPage";
import AddLibraryFilePage from "../pages/AddLibraryFilePage";
import ProfilePage from "../pages/ProfilePage";
import InvitationPage from "../pages/InvitationPage";
import AcceptInvite from "../pages/AcceptInvite";
import MessagesPage from "../pages/MessagesPage";
import AdminPage from "../pages/AdminPage";
import NaturalCaptureDebugPage from "../pages/NaturalCaptureDebugPage";
import RawCaptureExtractorSandboxPage from "../pages/RawCaptureExtractorSandboxPage";
import InviteCaregiverPage from "../pages/InviteCaregiverPage";
import InviteCarePartnerPage from "../pages/InviteCarePartnerPage";
import InviteTherapistPage from "../pages/InviteTherapistPage";
import InviteRoleSelectionPage from "../pages/InviteRoleSelectionPage";
import InviteSuccessPage from "../pages/InviteSuccessPage";
import AddChildPage from "../pages/Children/AddChildPage";
import EditChildPage from "../pages/Children/EditChildPage";
import MedicationReviewPage from "../pages/Children/MedicationReviewPage";
import MedicationDosePage from "../pages/Children/MedicationDosePage";
import MedicationRoundPage from "../pages/Children/MedicationRoundPage";
import MedicationRemindersPage from "../pages/Children/MedicationRemindersPage";
import AppointmentsPage from "../pages/Children/AppointmentsPage";
import TherapyPrepPage from "../pages/Children/TherapyPrepPage";
import IepGuidedCareJourneyPage from "../pages/Children/IepGuidedCareJourneyPage";
import CustomPreparePage from "../pages/Children/CustomPreparePage";
import PatternsTrendsPage from "../pages/Children/PatternsTrendsPage";
import ProvidersPage from "../pages/MedicalLog/ProvidersPage";
import DoctorVisitsPage from "../pages/MedicalLog/DoctorVisitsPage";
import { CARE_PROFILE_ROUTE } from "../constants/profileRoutes";

//When you update here update breadcrumbscomponent.js

const CareProfileRedirect = () => {
  const location = useLocation();
  const { childId } = useParams();
  const stateChildId = location.state?.childId || childId || null;

  return (
    <Navigate
      to={CARE_PROFILE_ROUTE}
      replace
      state={{
        ...(location.state || {}),
        childId: stateChildId,
      }}
    />
  );
};

const AppRoutes = () => {
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:1024.95px)");
  const isPublicMarketingRoute = [
    "/",
    "/how-it-works",
    "/cookie-policy",
    "/privacy-policy",
    "/terms",
    "/terms-of-service",
    "/autism-support",
    "/elder-care",
    "/family-care",
    "/interactive-demo",
  ].includes(location.pathname);
  const isAuthRoute = ["/login", "/register", "/forgot-password"].includes(location.pathname);
  const isMedicationTaskRoute = location.pathname.startsWith('/medications/') || location.pathname.endsWith('/medication-reminders');
  const shouldShowBreadcrumbs = !isPublicMarketingRoute && !isMobile && !isAuthRoute && location.pathname !== "/profile" && !isMedicationTaskRoute;

  return (
    <>
      {shouldShowBreadcrumbs && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            bgcolor: "background.default",
            boxShadow: "none",
          }}
        >
          <BreadcrumbsComponent />
        </Box>
      )}

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/autism-support" element={<AutismSupportPage />} />
        <Route path="/elder-care" element={<AudienceLandingPage audience="elder" />} />
        <Route path="/family-care" element={<AudienceLandingPage audience="family" />} />
        <Route path="/interactive-demo" element={<InteractiveDemoPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Navigate to="/login" replace />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/dashboard" element={<PanelDashboard />} />
        <Route path="/import-history" element={<ImportHistoryPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/professional-documentation" element={<ProfessionalDocumentationPage />} />
        <Route path="/my-notes-today" element={<MyNotesTodayPage />} />
        <Route path="/sources" element={<SourceHistoryPage />} />
        <Route path="/sources/:sourceId" element={<SourceResultsPage />} />
        <Route path="/care-knowledge" element={<CareKnowledgePage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/children/:childId/plans" element={<PlansPage />} />
        <Route path="/care-team" element={<CareTeamPage />} />
        {/* /progress-notes route removed - feature deprecated */}
        <Route path="/sensory" element={<SensoryPage />} />
        <Route path="/log" element={<Navigate to="/dashboard" replace />} />
        <Route path="/therapy-notes" element={<Navigate to="/dashboard" replace />} />
        <Route path="/templates" element={<TemplateLibraryPage />} />
        <Route path="/library/add" element={<AddLibraryFilePage />} />
        <Route path="/medical" element={<Navigate to="/dashboard" replace />} />
        <Route path="/providers" element={<ProvidersPage />} />
        <Route path="/medical-log/doctor-visits" element={<DoctorVisitsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/children/new" element={<AddChildPage />} />
        <Route path={CARE_PROFILE_ROUTE} element={<EditChildPage />} />
        <Route path="/children/:childId/medications/review/:sourceId" element={<MedicationReviewPage />} />
        <Route path="/children/:childId/medication-reminders" element={<MedicationRemindersPage />} />
        <Route path="/children/:childId/appointments" element={<AppointmentsPage />} />
        <Route path="/medications/doses/:occurrenceId" element={<MedicationDosePage />} />
        <Route path="/medications/rounds" element={<MedicationRoundPage />} />
        <Route path="/children/edit" element={<CareProfileRedirect />} />
        <Route path="/children/:childId/edit" element={<CareProfileRedirect />} />
        <Route path="/children/review" element={<CareProfileRedirect />} />
        <Route path="/children/:childId/review" element={<CareProfileRedirect />} />
        <Route path="/review-import" element={<Navigate to="/dashboard" replace />} />
        <Route path="/therapy-prep" element={<TherapyPrepPage />} />
        <Route path="/children/:childId/therapy-prep" element={<TherapyPrepPage />} />
        <Route path="/children/:childId/journeys/iep-meeting" element={<IepGuidedCareJourneyPage />} />
        <Route path="/prepare" element={<CustomPreparePage />} />
        <Route path="/children/:childId/journeys/custom/:draftId" element={<IepGuidedCareJourneyPage />} />
        <Route path="/patterns" element={<PatternsTrendsPage />} />
        <Route path="/children/:childId/patterns" element={<PatternsTrendsPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/natural-capture-debug" element={<NaturalCaptureDebugPage />} />
        <Route path="/admin/raw-capture-extractor" element={<RawCaptureExtractorSandboxPage />} />
        <Route path="/invitation/:invitationId" element={<InvitationPage />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route path="/invite" element={<InviteRoleSelectionPage />} />
        <Route path="/invite/caregiver" element={<InviteCaregiverPage />} />
        <Route path="/invite/carepartner" element={<InviteCarePartnerPage />} />
        <Route path="/invite/therapist" element={<InviteTherapistPage />} />
        <Route path="/invite/success" element={<InviteSuccessPage />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
